import {heightS,heightM} from './common'

const nowHeight = innerHeight * (innerWidth/750);

const nowSize = nowHeight<=heightS?'-s':nowHeight<=heightM?'-m':'';

const preloadList = [
  require(`../assets/images/home/bg${nowSize}.jpg`),
  require('../assets/images/home/btn-draw.png'),
  require('../assets/images/home/btn-rule.png'),
  require('../assets/images/home/logo.png'),
  require('../assets/images/home/title.png'),
  require('../assets/images/popup/qrcode.png'),
]

export default preloadList